import { connect } from 'react-redux'
import WordBankSlideCreateDialog from './create-dialog.jsx'
import { createSlide } from '../../../../stores/presentation/presentation.actions'
import { getCreateSlideDialog } from '../../../pages/lesson/builder/redux/builder.selectors.js'
import { closeCreateSlideDialog } from '../../../pages/lesson/builder/redux/builder.actions.js'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = state => {
  const createSlideDialog = getCreateSlideDialog(state)
  return {
    modalOpened:
      createSlideDialog.opened && createSlideDialog.type === 'WordBank'
  }
}

const mapDispatchToProps = dispatch => ({
  onClose: () => dispatch(closeCreateSlideDialog()),
  onSubmit: values => {
    dispatch(
      createSlide({
        type: 'WordBank',
        title: values.title,
        bank: values.bank,
        layout: 'column'
      })
    ).catch(errorHandler)
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WordBankSlideCreateDialog)
